"use client";

export { AnalyticsProvider } from "@dobbix/shared/analytics/provider";
